import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showLessDetails: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showDetails: {
		id: 'issue-field-service-entity.common.collapsible-field.card.show-details',
		defaultMessage: 'Show details',
		description: 'Label/Tooltip for button icon that shows details',
	},
	showLessDetails: {
		id: 'issue-field-service-entity.common.collapsible-field.card.show-less-details',
		defaultMessage: 'Show less details',
		description: 'Label/Tooltip for button icon that hides details',
	},
});
export default messages;
